import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cantact',
  templateUrl: './cantact.component.html',
  styleUrls: ['./cantact.component.css']
})
export class CantactComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  sendMessage(event: Event) {
    event.preventDefault();

    const form = event.target as HTMLFormElement;
    const formData = new FormData(form);

    fetch('https://formspree.io/f/mdkelryq', { // Replace with your Formspree ID
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(response => {
        if (response.ok) {
          document.getElementById('responseMessage')!.innerText = "Message Sent Successfully!";
          form.reset();
        } else {
          document.getElementById('responseMessage')!.innerText = "Error Sending Message!";
        }
      })
      .catch(error => {
        document.getElementById('responseMessage')!.innerText = "Error Sending Message!";
      });
  }

}
